import {useRef, useEffect} from 'react';

import type {LeadStatus} from 'nutshell-graphql-types';

import {Stage} from '../carousel/stage';

import {scrollToStage} from './helpers';

import styles from './stage-carousel-mini.module.css';

export type Stage = {
    id: string;
    name: string;
    isActive: boolean;
};

interface Props {
    stages: Stage[];
    isHot: boolean;
    leadStatus: LeadStatus;
}

export function StageCarouselMini(props: Props) {
    const activeIndex = props.stages.findIndex((s) => s.isActive);
    const activeStageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (activeStageRef.current) {
            scrollToStage(activeStageRef.current);
        }
    }, [activeIndex]);

    return (
        <div className={styles.container}>
            {props.stages.map((item, index) => {
                const isCurrentStage = index === activeIndex;
                const isActive = activeIndex >= 0 && index <= activeIndex;

                return (
                    <div
                        key={item.id}
                        className={styles['stage-wrapper']}
                        ref={isCurrentStage ? activeStageRef : undefined}
                    >
                        <Stage
                            stageName={item.name}
                            isActive={isActive}
                            isCurrentStage={isCurrentStage}
                            isStart={index === 0}
                            isEnd={index === props.stages.length - 1}
                            isSmall={true}
                            status={props.leadStatus}
                            isHot={props.isHot}
                            isDisplayOnly={true}
                        />
                    </div>
                );
            })}
        </div>
    );
}
